import { Link, LinkProps, useResolvedPath } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { languages_enum } from "redux/actions/globalSlice";

const supportedLangs = [
  languages_enum.ENGLISH, 
  // languages_enum.RUSSIAN
];

// Detect protocol-based URLs (viber:, tel:, mailto:, http:, https:, etc.)
const hasProtocol = (u: unknown): u is string =>
  typeof u === "string" && /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(u);

export function LocalizedLink(props: LinkProps) {
  const { to, ...rest } = props;

  // If it's a protocol/external URL, render a plain <a> and avoid hooks entirely
  if (hasProtocol(to)) {
    return (
      <a href={to as string} {...(rest as any)}>
        {rest.children}
      </a>
    );
  }

  // Otherwise, render the internal localized link that uses hooks
  return <InternalLocalizedLink {...props} />;
}

function InternalLocalizedLink({ to, ...rest }: LinkProps) {
  const language = useSelector((state: RootState) => state.global.language);
  const prefix = language === languages_enum.GEORGIAN ? "" : `/${language}`;

  // Hooks are called unconditionally in this component
  const resolved = useResolvedPath(to);

  // If already prefixed like "/en" or "/ru", skip adding prefix
  const firstSegment = resolved.pathname.split("/")[1];
  const alreadyPrefixed = supportedLangs.includes(firstSegment as languages_enum);

  const finalPath = alreadyPrefixed
    ? resolved.pathname
    : `${prefix}${resolved.pathname}`.replace(/\/{2,}/g, "/");

  const newTo =
    typeof to === "string"
      ? finalPath
      : { ...to, pathname: finalPath };

  return <Link to={newTo} {...rest} />;
}
